import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import api from "@/lib/api";
import { IMG } from "@/lib/content";
import { PricingTable, IncludeList } from "@/components/Pricing";

export default function DeepCleaning() {
  const [service, setService] = useState(null);
  useEffect(() => { api.get("/services").then((r) => setService(r.data.find((s) => s.slug === "deep"))).catch(() => {}); }, []);

  return (
    <div>
      <section className="relative h-[46vh] min-h-[340px]">
        <img src={IMG.deepKitchen} alt="Spotless, detailed kitchen clean" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-end pb-12">
          <p className="text-xs uppercase tracking-[0.25em] text-white/90">Top-to-bottom detail</p>
          <h1 className="mt-2 font-serif text-4xl sm:text-5xl text-white font-semibold">Deep Cleaning</h1>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-[#B87333]/10 border border-[#B87333]/30 rounded-2xl p-6 flex gap-4" data-testid="deep-notice">
          <AlertCircle className="text-[#B87333] shrink-0 mt-0.5" />
          <p className="text-[#2C2621] leading-relaxed">
            <strong>Deep-cleaning prices are starting prices.</strong> Masaya must inspect the property or review and approve current photos before confirming the final price and appointment.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="font-serif text-2xl text-[#2C2621]">What's included</h2>
            <p className="mt-2 text-[#635B52]">Everything in a standard clean, plus:</p>
            <div className="mt-4">
              <IncludeList items={[
                "Detailed bathroom and kitchen scrubbing",
                "Baseboards, doors, and doorframes",
                "Cabinet fronts and windowsills",
                "Reachable light fixtures and vents",
                "Blinds and other reachable surfaces",
              ]} />
            </div>
          </div>
          <div>
            <h2 className="font-serif text-2xl text-[#2C2621]">Priced separately</h2>
            <p className="mt-2 text-[#635B52]">These items require a custom quote:</p>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm text-[#635B52]">
              {["Interior ovens", "Interior refrigerators", "Interior windows", "Wall washing", "Carpet cleaning", "Laundry", "Mold", "Hazardous waste", "Excessive trash", "Heavy grease", "Excessive pet hair"].map((x) => (
                <li key={x} className="bg-[#F5F0E8] rounded-lg px-3 py-2">{x}</li>
              ))}
            </ul>
          </div>
        </div>

        <section className="mt-16">
          <h2 className="font-serif text-3xl text-[#2C2621] mb-8">Deep cleaning starting prices</h2>
          <PricingTable service={service} cta="estimate" />
        </section>

        <div className="mt-14 bg-[#2C2621] rounded-3xl p-10 text-center">
          <h3 className="font-serif text-3xl text-white">Deep cleans start with an estimate</h3>
          <p className="mt-2 text-[#E6DEC3] max-w-xl mx-auto">Submit your property details and current photos. We'll review, confirm a final price, and schedule your appointment.</p>
          <Link to="/get-estimate" className="mt-6 inline-block bg-[#B87333] hover:bg-[#A06127] text-white font-medium rounded-full px-8 py-3.5 shadow-md transition-all" data-testid="deep-estimate-btn">Get an Estimate</Link>
        </div>
      </div>
    </div>
  );
}
